import { Ban, Snowflake } from 'lucide-react'
import { splitNote, outcomeLabel, outcomePillCls } from '../../data/implantOutcomes.js'

/* A recall Note the way a person should read it.
 *
 * The implant campaign stores its outcome as a prefix inside the Note —
 * `[IMP|A|OC] ทำที่คลินิกใกล้บ้าน` — because the recall table has no outcome
 * column (see src/data/implantOutcomes.js). That prefix is for api 650 and the
 * reports. A reader gets a pill instead: "รากเทียม · ไปทำที่อื่นแล้ว", then the words.
 *
 * The "รากเทียม ·" says WHERE the note came from. These notes also show on
 * /follow-ups/recall and the patient page, where a regular recall caller would
 * otherwise read "เคสไม่เหมาะ" as a verdict on every call. It is not: a code only
 * ever acts on the implant lists (api 678 parks NO/OC patients off them), and
 * nothing else reads these notes. The clinic's do-not-recall is patient.status
 * ยกเลิกเคส; the ยกเลิกเคส chip (DNC) writes that status, its note is only the record.
 *
 * Anything without the anchored prefix renders exactly as it always did. The
 * caller owns the empty state. `title` overrides the pill's own tooltip — a
 * truncating cell passes the full note so hovering the pill still shows it. */
export default function RecallNoteText({ note, title }) {
  const n = splitNote(note)
  if (!n.code) return n.text
  return (
    <>
      <OutcomePill note={n} title={title} />
      {n.text && <span className="ml-1.5">{n.text}</span>}
    </>
  )
}

/** The group's icon, for the two outcomes whose effect outlasts the call: a snowflake
 *  for พัก (freeze) until a new round — also view R's icon in tab 1 — and a ban for
 *  ยกเลิกเคส. Null for the rest; the colour alone is enough where nothing happens. */
export function OutcomeIcon({ outcome, size = 11 }) {
  if (outcome?.cancels) return <Ban size={size} aria-hidden className="shrink-0" />
  if (outcome?.excludes) return <Snowflake size={size} aria-hidden className="shrink-0" />
  return null
}

/** The pill alone — the edit box shows it beside the text, where the code is fixed. */
export function OutcomePill({ note, title }) {
  return (
    <span title={title || `รากเทียม ลิสต์ ${note.list} · ${outcomeLabel(note)}`}
      className={`inline-flex items-center gap-1 rounded border px-1.5 py-px text-[11px] font-medium whitespace-nowrap align-[1px] ${outcomePillCls(note.outcome?.tone)}`}>
      <OutcomeIcon outcome={note.outcome} size={10} />
      <span className="opacity-70">รากเทียม ·</span>{outcomeLabel(note)}
    </span>
  )
}
